import { ISignupUser } from 'src/entities/user';
import { IValidationRule, required, emailFormat, phoneFormat, isChecked, isValidLength } from './validations';
import { } from './userDetailsRules';
import { reservationEndFields } from './reservationEndRules';
import config from 'src/constants';

const getSignupFields = () => {
    const passwordField: keyof ISignupUser = 'Password';

    return {
        ...reservationEndFields,
        Password: passwordField
    }
}

export const signupFields = getSignupFields();

export const signupRules: IValidationRule[] = [
    required(signupFields.Name),
    required(signupFields.Email),
    emailFormat(signupFields.Email),
    required(signupFields.Phone),
    phoneFormat(signupFields.Phone),
    isChecked(signupFields.PrivacyStatementAccepted),
    required(signupFields.Password),
    isValidLength(signupFields.Password, config.MIN_PASSWORD_LENGTH, config.MAX_PASSWORD_LENGTH)    
];